var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "l-checkout__row" }, [
    _c(
      "div",
      { staticClass: "l-customer__left" },
      [
        _c(
          "ValidationObserver",
          { ref: "customerForm" },
          [
            _vm.addresses.length > 0
              ? _c(
                  "div",
                  { staticClass: "l-customer__field l-customer__field--full" },
                  [
                    _c("ValidationProvider", {
                      attrs: { name: "email", rules: "required|email" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return _c(
                                "div",
                                {
                                  staticClass: "o-input",
                                  class: {
                                    "o-input--error": errors && errors.length
                                  }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.email,
                                        expression: "email"
                                      }
                                    ],
                                    staticClass:
                                      "w-full validate input input--readonly",
                                    class: { valid: _vm.email },
                                    attrs: {
                                      type: "email",
                                      id: "email",
                                      name: "email",
                                      required: "required",
                                      readonly: _vm.isReadOnly
                                    },
                                    domProps: { value: _vm.email },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.email = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", { attrs: { for: "email" } }, [
                                    _vm._v(" E-mail ")
                                  ])
                                ]
                              )
                            }
                          }
                        ],
                        null,
                        false,
                        1917156615
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.addresses.length > 0
              ? _c("v-select", {
                  attrs: {
                    options: _vm.shippingAddresses,
                    placeholder: _vm.translations.choose,
                    reduce: function(shippingAddresses) {
                      return shippingAddresses.code
                    }
                  },
                  model: {
                    value: _vm.shippingAddressId,
                    callback: function($$v) {
                      _vm.shippingAddressId = $$v
                    },
                    expression: "shippingAddressId"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.showShippingInputs
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.shippingAddressId,
                      expression: "shippingAddressId"
                    }
                  ],
                  staticClass: "w-full input",
                  attrs: {
                    type: "hidden",
                    id: "shippingAddress-id",
                    name: "shippingAddressId"
                  },
                  domProps: { value: _vm.shippingAddressId },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.shippingAddressId = $event.target.value
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showShippingInputs
              ? _c(
                  "div",
                  { staticClass: "l-customer__fields shippingAddress" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--full"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: {
                            name: "shippingBussinesname",
                            rules: "required"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.shippingAddress.businessName,
                                            expression:
                                              "shippingAddress.businessName"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid:
                                            _vm.shippingAddress.businessName
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "shippingAddress[businessName]",
                                          name: "shippingAddress[businessName]",
                                          required: "required",
                                          readonly: _vm.readOnly
                                        },
                                        domProps: {
                                          value:
                                            _vm.shippingAddress.businessName
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.shippingAddress,
                                              "businessName",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "shippingAddress[businessName]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.translations.customer
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            4032267870
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--full"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "shippingTaxId", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.shippingAddress.businessTaxId,
                                            expression:
                                              "shippingAddress.businessTaxId"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid:
                                            _vm.shippingAddress.businessTaxId
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "shippingAddress[businessTaxId]",
                                          name:
                                            "shippingAddress[businessTaxId]",
                                          required: "required",
                                          readonly: _vm.readOnly
                                        },
                                        domProps: {
                                          value:
                                            _vm.shippingAddress.businessTaxId
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.shippingAddress,
                                              "businessTaxId",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for:
                                              "shippingAddress[businessTaxId]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.translations.vat) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            3059308921
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--half"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "shippingFname", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.shippingAddress.firstName,
                                            expression:
                                              "shippingAddress.firstName"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.shippingAddress.firstName
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "shippingAddress[firstName]",
                                          name: "shippingAddress[firstName]",
                                          required: "required"
                                        },
                                        domProps: {
                                          value: _vm.shippingAddress.firstName
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.shippingAddress,
                                              "firstName",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "shippingAddress[firstName]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.translations.firstName
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            675825745
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--half"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "shippingLName", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.shippingAddress.lastName,
                                            expression:
                                              "shippingAddress.lastName"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.shippingAddress.lastName
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "shippingAddress[lastName]",
                                          name: "shippingAddress[lastName]",
                                          required: "required"
                                        },
                                        domProps: {
                                          value: _vm.shippingAddress.lastName
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.shippingAddress,
                                              "lastName",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "shippingAddress[lastName]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.translations.lastName
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            1453610561
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--full"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "shippingPhone", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.shippingAddress.phone,
                                            expression: "shippingAddress.phone"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.shippingAddress.phone
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "shippingAddress[phone]",
                                          name: "shippingAddress[phone]",
                                          required: "required"
                                        },
                                        domProps: {
                                          value: _vm.shippingAddress.phone
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.shippingAddress,
                                              "phone",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "shippingAddress[phone]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.translations.phone) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            2949183952
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.addresses.length == 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "l-customer__field l-customer__field--full"
                          },
                          [
                            _c("ValidationProvider", {
                              attrs: { name: "email", rules: "required|email" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return _c(
                                        "div",
                                        {
                                          staticClass: "o-input",
                                          class: {
                                            "o-input--error":
                                              errors && errors.length
                                          }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.email,
                                                expression: "email"
                                              }
                                            ],
                                            staticClass:
                                              "w-full validate input",
                                            class: { valid: _vm.email },
                                            attrs: {
                                              type: "email",
                                              id: "email",
                                              name: "email",
                                              required: "required"
                                            },
                                            domProps: { value: _vm.email },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.email = $event.target.value
                                              }
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { attrs: { for: "email" } },
                                            [_vm._v(" E-mail ")]
                                          )
                                        ]
                                      )
                                    }
                                  }
                                ],
                                null,
                                false,
                                785121851
                              )
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--full"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "shippingAddress", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.shippingAddress.address1,
                                            expression:
                                              "shippingAddress.address1"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.shippingAddress.address1
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "shippingAddress[address1]",
                                          name: "shippingAddress[address1]",
                                          required: "required"
                                        },
                                        domProps: {
                                          value: _vm.shippingAddress.address1
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.shippingAddress,
                                              "address1",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "shippingAddress[address1]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.translations.address) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            1770376442
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--half"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "shippingZip", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.shippingAddress.zipCode,
                                            expression:
                                              "shippingAddress.zipCode"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.shippingAddress.zipCode
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "shippingAddress[zipCode]",
                                          name: "shippingAddress[zipCode]",
                                          required: "required"
                                        },
                                        domProps: {
                                          value: _vm.shippingAddress.zipCode
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.shippingAddress,
                                              "zipCode",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "shippingAddress[zipCode]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.translations.zipCode) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            4155023266
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--half"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "shippingCity", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.shippingAddress.city,
                                            expression: "shippingAddress.city"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.shippingAddress.city
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "shippingAddress[city]",
                                          name: "shippingAddress[city]",
                                          required: "required"
                                        },
                                        domProps: {
                                          value: _vm.shippingAddress.city
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.shippingAddress,
                                              "city",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "shippingAddress[city]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.translations.city) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            1079822283
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--full"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "shippingCountry", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c("v-select", {
                                    class: {
                                      "select-error": errors && errors.length
                                    },
                                    attrs: {
                                      options: _vm.enabledCountries,
                                      placeholder: _vm.translations.country,
                                      reduce: function(enabledCountries) {
                                        return enabledCountries.code
                                      }
                                    },
                                    model: {
                                      value: _vm.shippingAddress.countryId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.shippingAddress,
                                          "countryId",
                                          $$v
                                        )
                                      },
                                      expression: "shippingAddress.countryId"
                                    }
                                  })
                                }
                              }
                            ],
                            null,
                            false,
                            976796192
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.shippingAddress.countryId,
                          expression: "shippingAddress.countryId"
                        }
                      ],
                      attrs: {
                        type: "hidden",
                        id: "shippingAddress-id",
                        name: "shippingAddress[countryId]"
                      },
                      domProps: { value: _vm.shippingAddress.countryId },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.shippingAddress,
                            "countryId",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.alternateBilling,
                  expression: "alternateBilling"
                }
              ],
              staticClass: "o-checkbox__input",
              staticStyle: { display: "none" },
              attrs: { id: "cbx", type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.alternateBilling)
                  ? _vm._i(_vm.alternateBilling, null) > -1
                  : _vm.alternateBilling
              },
              on: {
                change: function($event) {
                  var $$a = _vm.alternateBilling,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.alternateBilling = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.alternateBilling = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.alternateBilling = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("label", { staticClass: "o-checkbox", attrs: { for: "cbx" } }, [
              _c("span", [
                _c(
                  "svg",
                  {
                    attrs: { width: "12px", height: "9px", viewbox: "0 0 12 9" }
                  },
                  [_c("polyline", { attrs: { points: "1 5 4 8 11 1" } })]
                )
              ]),
              _c("span", [_vm._v(_vm._s(_vm.translations.isBilling))])
            ]),
            _vm._v(" "),
            _c("input", {
              attrs: { type: "hidden", name: "billingAddressSameAsShipping" },
              domProps: { value: !_vm.alternateBilling }
            }),
            _vm._v(" "),
            _vm.addresses.length > 0 && _vm.alternateBilling
              ? _c("v-select", {
                  attrs: {
                    options: _vm.billingAddresses,
                    placeholder: _vm.translations.choose,
                    reduce: function(billingAddresses) {
                      return billingAddresses.code
                    }
                  },
                  model: {
                    value: _vm.billingAddressId,
                    callback: function($$v) {
                      _vm.billingAddressId = $$v
                    },
                    expression: "billingAddressId"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.alternateBilling && !_vm.showBillingInputs
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.shippingAddressId,
                      expression: "shippingAddressId"
                    }
                  ],
                  staticClass: "w-full input",
                  attrs: {
                    type: "hidden",
                    id: "shippingAddress-id",
                    name: "shippingAddress[id]"
                  },
                  domProps: { value: _vm.shippingAddressId },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.shippingAddressId = $event.target.value
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.alternateBilling && _vm.showBillingInputs
              ? _c(
                  "div",
                  { staticClass: "l-customer__fields billingAddress" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--full"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "billingBusiness", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.billingAddress.businessName,
                                            expression:
                                              "billingAddress.businessName"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.billingAddress.businessName
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "billingAddress[businessName]",
                                          name: "billingAddress[businessName]",
                                          required: "required",
                                          readonly: _vm.readOnly
                                        },
                                        domProps: {
                                          value: _vm.billingAddress.businessName
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.billingAddress,
                                              "businessName",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "billingAddress[businessName]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.translations.customer
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            3524461694
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--full"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "billingTax", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.billingAddress.businessTaxId,
                                            expression:
                                              "billingAddress.businessTaxId"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid:
                                            _vm.billingAddress.businessTaxId
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "billingAddress[businessTaxId]",
                                          name: "billingAddress[businessTaxId]",
                                          required: "required",
                                          readonly: _vm.readOnly
                                        },
                                        domProps: {
                                          value:
                                            _vm.billingAddress.businessTaxId
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.billingAddress,
                                              "businessTaxId",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "billingAddress[businessTaxId]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.translations.vat) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            376026137
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--half"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: {
                            name: "billingFirstname",
                            rules: "required"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.billingAddress.firstName,
                                            expression:
                                              "billingAddress.firstName"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.billingAddress.firstName
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "billingAddress[firstName]",
                                          name: "billingAddress[firstName]",
                                          required: "required"
                                        },
                                        domProps: {
                                          value: _vm.billingAddress.firstName
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.billingAddress,
                                              "firstName",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "billingAddress[firstName]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.translations.firstName
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            289972529
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--half"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "billingLastname", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.billingAddress.lastName,
                                            expression:
                                              "billingAddress.lastName"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.billingAddress.lastName
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "billingAddress[lastName]",
                                          name: "billingAddress[lastName]",
                                          required: "required"
                                        },
                                        domProps: {
                                          value: _vm.billingAddress.lastName
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.billingAddress,
                                              "lastName",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "billingAddress[lastName]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.translations.lastName
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            1185586145
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--full"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "billingPhone", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.billingAddress.phone,
                                            expression: "billingAddress.phone"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.billingAddress.phone
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "billingAddress[phone]",
                                          name: "billingAddress[phone]",
                                          required: "required"
                                        },
                                        domProps: {
                                          value: _vm.billingAddress.phone
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.billingAddress,
                                              "phone",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "billingAddress[phone]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.translations.phone) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            3245332336
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--full"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "billingAddress", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.billingAddress.address1,
                                            expression:
                                              "billingAddress.address1"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.billingAddress.address1
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "billingAddress[address1]",
                                          name: "billingAddress[address1]",
                                          required: "required"
                                        },
                                        domProps: {
                                          value: _vm.billingAddress.address1
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.billingAddress,
                                              "address1",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "billingAddress[address1]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.translations.address) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            692669082
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--half"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "billingZip", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.billingAddress.zipCode,
                                            expression: "billingAddress.zipCode"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.billingAddress.zipCode
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "billingAddress[zipCode]",
                                          name: "billingAddress[zipCode]",
                                          required: "required"
                                        },
                                        domProps: {
                                          value: _vm.billingAddress.zipCode
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.billingAddress,
                                              "zipCode",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "billingAddress[zipCode]"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.translations.zipCode) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            906210114
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--half"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "billingCity", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "o-input",
                                      class: {
                                        "o-input--error":
                                          errors && errors.length
                                      }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.billingAddress.city,
                                            expression: "billingAddress.city"
                                          }
                                        ],
                                        staticClass: "w-full validate input",
                                        class: {
                                          valid: _vm.billingAddress.city
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "billingAddress[city]",
                                          name: "billingAddress[city]",
                                          required: "required"
                                        },
                                        domProps: {
                                          value: _vm.billingAddress.city
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.billingAddress,
                                              "city",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          attrs: { for: "billingAddress[city]" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.translations.city) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            false,
                            2115500779
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "l-customer__field l-customer__field--full"
                      },
                      [
                        _c("ValidationProvider", {
                          attrs: { name: "billingCountry", rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var errors = ref.errors
                                  return _c("v-select", {
                                    class: {
                                      "select-error": errors && errors.length
                                    },
                                    attrs: {
                                      options: _vm.enabledCountries,
                                      placeholder: _vm.translations.country,
                                      reduce: function(enabledCountries) {
                                        return enabledCountries.code
                                      }
                                    },
                                    model: {
                                      value: _vm.billingAddress.countryId,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.billingAddress,
                                          "countryId",
                                          $$v
                                        )
                                      },
                                      expression: "billingAddress.countryId"
                                    }
                                  })
                                }
                              }
                            ],
                            null,
                            false,
                            1684613977
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.shippingAddress.countryId,
                          expression: "shippingAddress.countryId"
                        }
                      ],
                      attrs: {
                        type: "hidden",
                        id: "shippingAddress-id",
                        name: "billingAddress[countryId]"
                      },
                      domProps: { value: _vm.shippingAddress.countryId },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.shippingAddress,
                            "countryId",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "l-customer__right" }, [_vm._t("right")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }